export enum CourseLength {
  M1 = '1 miesiąc',
  M3 = '3 miesiące',
  M6 = '6 miesięcy',
  M12 = '12 miesięcy',
}
